import {
	Component,
	EventEmitter,
	Input,
	OnChanges,
	OnDestroy,
	OnInit,
	Output,
} from '@angular/core'
import { Package } from '../../models/package.model'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { Subscription } from 'rxjs'

@Component({
	selector: 'app-add-package-info',
	templateUrl: './add-package-info.component.html',
	styleUrls: ['./add-package-info.component.scss'],
})
export class AddPackageInfoComponent implements OnInit, OnChanges, OnDestroy {
	@Input() packageData!: Package
	@Input() isEditMode!: boolean
	viewMode: boolean = true
	@Output() emitData = new EventEmitter()
	formData: FormGroup = new FormGroup({})
	subscription: Subscription = new Subscription()
	constructor() {}
	ngOnChanges(): void {
		this.initForm()
	}

	ngOnInit(): void {
		this.initForm()
	}
	initForm() {
		this.formData = new FormGroup({
			name: new FormGroup({
				en: new FormControl(
					{
						value: this.packageData?.name?.en || '',
						disabled: this.packageData?.hasBooking ? true : false,
					},
					Validators.required
				),
				ar: new FormControl(
					{
						value: this.packageData?.name?.ar || '',
						disabled: this.packageData?.hasBooking ? true : false,
					},
					Validators.required
				),
			}),
			description: new FormGroup({
				en: new FormControl(this.packageData?.description?.en || ''),
				ar: new FormControl(this.packageData?.description?.ar || ''),
			}),
			instructions: new FormGroup({
				en: new FormControl(this.packageData?.instructions?.en || ''),
				ar: new FormControl(this.packageData?.instructions?.ar || ''),
			}),
			price: new FormControl(
				{
					value: this.packageData?.price || null,
					disabled: this.packageData?.hasBooking ? true : false,
				},
				[Validators.required, Validators.min(1), Validators.pattern('^[0-9]*$')]
			),
		})
		if (!this.isEditMode)
			this.subscription.add(
				this.formData.valueChanges.subscribe(() => this.onSave())
			)
	}
	getController(controlName: string) {
		return this.formData.controls[controlName]
	}
	checkLength(controller: string, input: any, maxLength: number) {
		if (String(input.target.value).length > maxLength) {
			input.key == 'Backspace' ? '' : event?.preventDefault()
		}
	}
	skipLetterE(event: any) {
		if (event.key.toLowerCase() === 'e' || event.key.toLowerCase() === '.') {
			event.preventDefault()
		}
	}
	allowOnlyNumbers(event: KeyboardEvent) {
		const allowedKeys = [
			'Backspace',
			'Tab',
			'End',
			'Home',
			'ArrowLeft',
			'ArrowRight',
			'ArrowUp',
			'ArrowDown',
		]
		const isNumber = /^[0-9]$/

		if (allowedKeys.includes(event.key) || isNumber.test(event.key)) {
			return // Allow navigation and numeric keys
		} else {
			event.preventDefault() // Prevent non-numeric keys
		}
	}
	onSave(isSave?: boolean) {
		this.emitData.emit({
			value: this.formData.getRawValue(),
			isValid: this.formData.valid,
			isSave: isSave,
			index: 0,
		})
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe()
	}
}
